"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = randomId;

var _mathRandom = _interopRequireDefault(require("math-random"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-magic-numbers: ["error", { "ignore": [2, 5, 36] }] */
function randomId() {
  var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  return (0, _mathRandom.default)().toString(36).substr(2, maxLength);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9yYW5kb21JZC50cyJdLCJuYW1lcyI6WyJyYW5kb21JZCIsIm1heExlbmd0aCIsInRvU3RyaW5nIiwic3Vic3RyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRUE7Ozs7QUFGQTtBQUllLFNBQVNBLFFBQVQsR0FBaUQ7QUFBQSxNQUEvQkMsU0FBK0IsdUVBQVgsQ0FBVztBQUM5RCxTQUFPLDJCQUFTQyxRQUFULENBQWtCLEVBQWxCLEVBQXNCQyxNQUF0QixDQUE2QixDQUE3QixFQUFnQ0YsU0FBaEMsQ0FBUDtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyIvKiBlc2xpbnQgbm8tbWFnaWMtbnVtYmVyczogW1wiZXJyb3JcIiwgeyBcImlnbm9yZVwiOiBbMiwgNSwgMzZdIH1dICovXG5cbmltcG9ydCByYW5kb20gZnJvbSAnbWF0aC1yYW5kb20nO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiByYW5kb21JZChtYXhMZW5ndGg6IG51bWJlciA9IDUpOiBzdHJpbmcge1xuICByZXR1cm4gcmFuZG9tKCkudG9TdHJpbmcoMzYpLnN1YnN0cigyLCBtYXhMZW5ndGgpO1xufVxuIl19